module.exports = __webpack_public_path__ + "static/media/YF100_1.a4913157.jpg";